<h2 mat-dialog-title>Ver como</h2>
<mat-dialog-content>
  <p class="help">
    Vê a aplicação como o utilizador escolhido durante 60 minutos. Iniciar uma nova sessão substitui a atual.
  </p>

  <div class="tabs" role="tablist">
    <button type="button" role="tab" class="tab" [class.tab--active]="mode() === 'pharmacies'" [attr.aria-selected]="mode() === 'pharmacies'" (click)="setMode('pharmacies')">Farmácias</button>
    <button type="button" role="tab" class="tab" [class.tab--active]="mode() === 'lab'" [attr.aria-selected]="mode() === 'lab'" (click)="setMode('lab')">Laboratório</button>
  </div>

  @if (loading()) {
    <p class="empty-state">A carregar...</p>
  } @else if (targets()) {
    @if (mode() === 'pharmacies') {
      <label class="field">
        <span class="label">Pesquisar farmácia</span>
        <input type="text" placeholder="Nome ou código ANF" [ngModel]="search()" (ngModelChange)="search.set($event)" />
      </label>
      <div class="list" role="group" aria-label="Farmácias">
        @for (pharmacy of filteredPharmacies(); track pharmacy.codigoAnf) {
          <label class="row">
            <span class="code">{{ pharmacy.codigoAnf }}</span>
            <span class="name" [title]="pharmacy.nome">{{ pharmacy.nome }}</span>
            <input type="checkbox" [checked]="isSelected(pharmacy.codigoAnf)" (change)="toggle(pharmacy.codigoAnf)" />
          </label>
        } @empty {
          <span class="empty-state">Nenhuma farmácia encontrada.</span>
        }
      </div>
      <p class="help">{{ selectedCodes().length }} selecionada(s)</p>
      <label class="field">
        <span class="label">Nível de acesso</span>
        <input type="number" step="1" min="0" placeholder="Igual ao da farmácia"
               [value]="accessLevel() ?? ''" (change)="onAccessLevelChange($any($event.target).value)" />
      </label>
      <p class="help">Vazio usa o nível da farmácia. Os relatórios Tableau mostrados dependem do nível.</p>
    } @else {
      <label class="field">
        <span class="label">Laboratório</span>
        <select [ngModel]="labId() === null ? '' : '' + labId()" (ngModelChange)="onLabChange($event)">
          <option value="">Escolha um laboratório</option>
          @for (lab of targets()!.labs; track lab.laboratorioId) {
            <option [value]="lab.laboratorioId">{{ lab.nome }}</option>
          }
        </select>
      </label>
      @if (labId() !== null) {
        <label class="field">
          <span class="label">Contacto</span>
          <select [ngModel]="contactId() === null ? '' : '' + contactId()" (ngModelChange)="onContactChange($event)">
            <option value="">Escolha um contacto</option>
            @for (contact of contacts(); track contact.id) {
              <option [value]="contact.id">{{ contact.nome }} ({{ contact.email }})</option>
            }
          </select>
        </label>
        @if (contacts().length === 0) {
          <p class="empty-state">Este laboratório não tem contactos.</p>
        }
      }
    }
  }

  @if (errorMessage()) {
    <p class="error-text">{{ errorMessage() }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="secondary-btn" type="button" (click)="close()" [disabled]="saving()">Cancelar</button>
  <button class="primary-btn" type="button" (click)="start()" [disabled]="!canStart() || saving()">{{ saving() ? 'A iniciar...' : 'Iniciar' }}</button>
</mat-dialog-actions>
